import { render, staticRenderFns } from "./selectGoodsMonitor.vue?vue&type=template&id=50cf2905&scoped=true"
import script from "./selectGoodsMonitor.vue?vue&type=script&lang=js"
export * from "./selectGoodsMonitor.vue?vue&type=script&lang=js"
import style0 from "./selectGoodsMonitor.vue?vue&type=style&index=0&id=50cf2905&prod&lang=scss&scoped=true"
import style1 from "./selectGoodsMonitor.vue?vue&type=style&index=1&id=50cf2905&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cf2905",
  null
  
)

export default component.exports